import venueImageUrl from './assets/images/carlo-cristina-venue-image.webp';

const INVITATION_PATH = '/invitations/custom/carlo-and-cristina-wedding';

if (window.location.pathname.includes(INVITATION_PATH)) {
  const STYLE_ID = 'cc-gallery-swipe-enhancements';

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .cc-gallery-grid {
        touch-action: pan-y pinch-zoom;
        overscroll-behavior-x: contain;
        scroll-snap-type: x mandatory !important;
        scroll-padding-inline: clamp(16px, 4vw, 28px);
        -webkit-overflow-scrolling: touch;
        cursor: grab;
      }

      .cc-gallery-grid.is-dragging {
        scroll-snap-type: none !important;
        cursor: grabbing;
      }

      .cc-gallery-tile {
        scroll-snap-align: center !important;
        scroll-snap-stop: always;
      }

      .cc-gallery-open,
      .cc-gallery-open img {
        -webkit-user-drag: none;
        user-select: none;
      }

      .cc-gallery-grid:focus-visible {
        outline: 2px solid rgba(231, 210, 160, .75);
        outline-offset: 6px;
        border-radius: 14px;
      }

      .cc-venue-photo {
        width: min(100%, 680px);
        margin: 0 auto clamp(22px, 4vw, 32px);
        overflow: hidden;
        border-radius: 18px;
        border: 1px solid rgba(231, 210, 160, .3);
        background: rgba(251, 243, 228, .08);
        box-shadow: 0 16px 38px rgba(20, 10, 4, .34);
        aspect-ratio: 16 / 9;
      }

      .cc-venue-photo img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }

      .cc-faq-item {
        transition:
          border-color .42s ease,
          box-shadow .42s ease,
          transform .42s cubic-bezier(.22, 1, .36, 1) !important;
      }

      .cc-faq-item.is-open {
        transform: translateY(-1px);
        border-color: rgba(201, 147, 47, .42);
        box-shadow: 0 13px 28px rgba(74, 52, 35, .16) !important;
      }

      .cc-faq-trigger {
        background-size: 165% 100% !important;
        background-position: 0 50% !important;
        transition:
          background-position .5s cubic-bezier(.22, 1, .36, 1),
          filter .25s ease,
          box-shadow .25s ease !important;
      }

      .cc-faq-item.is-open .cc-faq-trigger {
        background-position: 100% 50% !important;
      }

      .cc-faq-chevron {
        position: relative;
        width: 30px !important;
        height: 30px !important;
        flex: 0 0 30px !important;
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        margin: 0 !important;
        border-radius: 999px;
        background: rgba(255, 250, 243, .13);
        box-shadow:
          inset 0 0 0 1px rgba(255, 250, 243, .2),
          0 4px 12px rgba(44, 24, 12, .12);
        transform: none !important;
        transition:
          background-color .35s ease,
          box-shadow .35s ease,
          scale .22s ease !important;
      }

      .cc-faq-chevron svg {
        display: block;
        width: 17px;
        height: 17px;
        overflow: visible;
        transform: rotate(0deg);
        transform-origin: 50% 50%;
        filter: drop-shadow(0 1px 1px rgba(45, 25, 12, .18));
        transition: transform .58s cubic-bezier(.34, 1.56, .64, 1);
      }

      .cc-faq-chevron-circle {
        fill: rgba(255, 250, 243, .08);
        stroke: rgba(255, 250, 243, .22);
        stroke-width: 1;
        transition: fill .35s ease, stroke .35s ease;
      }

      .cc-faq-chevron-path {
        fill: none;
        stroke: #fffaf3;
        stroke-width: 2.25;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-dasharray: 16;
        stroke-dashoffset: 0;
        transition: stroke .35s ease, stroke-dashoffset .45s ease;
      }

      .cc-faq-item.is-open .cc-faq-chevron {
        background: rgba(248, 229, 199, .94);
        box-shadow:
          inset 0 0 0 1px rgba(122, 79, 51, .16),
          0 6px 15px rgba(44, 24, 12, .2);
        transform: none !important;
      }

      .cc-faq-item.is-open .cc-faq-chevron svg {
        transform: rotate(180deg);
      }

      .cc-faq-item.is-open .cc-faq-chevron-circle {
        fill: rgba(122, 79, 51, .06);
        stroke: rgba(122, 79, 51, .14);
      }

      .cc-faq-item.is-open .cc-faq-chevron-path {
        stroke: #7a4f33;
      }

      .cc-faq-trigger.is-arrow-pressing .cc-faq-chevron {
        scale: .84;
      }

      .cc-faq-trigger.cc-faq-arrow-pop .cc-faq-chevron {
        animation: ccFaqArrowPop .52s cubic-bezier(.22, 1, .36, 1);
      }

      .cc-faq-trigger.cc-faq-arrow-pop .cc-faq-chevron-path {
        animation: ccFaqArrowStroke .52s ease;
      }

      .cc-faq-answer-content {
        opacity: 0;
        transform: translateY(-5px);
        transition:
          opacity .28s ease,
          transform .42s cubic-bezier(.22, 1, .36, 1);
      }

      .cc-faq-item.is-open .cc-faq-answer-content {
        opacity: 1;
        transform: translateY(0);
        transition-delay: .07s;
      }

      @keyframes ccFaqArrowPop {
        0% { scale: .9; }
        42% { scale: 1.14; }
        72% { scale: .97; }
        100% { scale: 1; }
      }

      @keyframes ccFaqArrowStroke {
        0% { stroke-dashoffset: 0; }
        45% { stroke-dashoffset: 16; }
        46% { stroke-dashoffset: -16; }
        100% { stroke-dashoffset: 0; }
      }

      @media (max-width: 640px) {
        .cc-venue-photo {
          border-radius: 14px;
          margin-bottom: 22px;
          aspect-ratio: 4 / 3;
        }

        .cc-faq-chevron {
          width: 28px !important;
          height: 28px !important;
          flex-basis: 28px !important;
          margin-top: 1px !important;
        }

        .cc-faq-chevron svg {
          width: 16px;
          height: 16px;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .cc-faq-item,
        .cc-faq-trigger,
        .cc-faq-chevron,
        .cc-faq-chevron svg,
        .cc-faq-chevron-path,
        .cc-faq-answer-content {
          animation: none !important;
          transition: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const getGalleryItems = (gallery) => Array.from(gallery.querySelectorAll('.cc-gallery-tile'));

  const getNearestIndex = (gallery, items) => {
    if (!items.length) return 0;

    const galleryCenter = gallery.scrollLeft + gallery.clientWidth / 2;
    let nearestIndex = 0;
    let nearestDistance = Infinity;

    items.forEach((item, index) => {
      const itemCenter = item.offsetLeft + item.offsetWidth / 2;
      const distance = Math.abs(itemCenter - galleryCenter);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  };

  const scrollToGalleryItem = (gallery, index) => {
    const items = getGalleryItems(gallery);
    if (!items.length) return;

    const safeIndex = Math.max(0, Math.min(items.length - 1, index));
    const item = items[safeIndex];
    const left = item.offsetLeft - (gallery.clientWidth - item.offsetWidth) / 2;

    gallery.scrollTo({
      left: Math.max(0, left),
      behavior: 'smooth',
    });
  };

  const enhanceGallery = () => {
    const gallery = document.querySelector('.cc-gallery-grid');
    if (!gallery || gallery.dataset.swipeEnhanced === 'true') return Boolean(gallery);

    gallery.dataset.swipeEnhanced = 'true';
    gallery.tabIndex = 0;
    gallery.setAttribute('aria-label', 'Photo gallery. Swipe left or right to browse photos.');
    gallery.setAttribute('aria-roledescription', 'swipeable photo carousel');

    gallery.querySelectorAll('img').forEach((image) => {
      image.draggable = false;
    });

    let pointerStartX = 0;
    let pointerStartIndex = 0;
    let activePointerId = null;
    let didSwipe = false;

    gallery.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      const items = getGalleryItems(gallery);
      pointerStartX = event.clientX;
      pointerStartIndex = getNearestIndex(gallery, items);
      activePointerId = event.pointerId;
      didSwipe = false;
    });

    gallery.addEventListener('pointermove', (event) => {
      if (activePointerId !== event.pointerId) return;
      if (Math.abs(event.clientX - pointerStartX) > 10) didSwipe = true;
    }, { passive: true });

    const finishSwipe = (event) => {
      if (activePointerId !== event.pointerId) return;

      const deltaX = event.clientX - pointerStartX;
      const swipeThreshold = Math.min(70, Math.max(38, gallery.clientWidth * 0.09));
      const items = getGalleryItems(gallery);
      let targetIndex = getNearestIndex(gallery, items);

      if (didSwipe && Math.abs(deltaX) >= swipeThreshold) {
        targetIndex = pointerStartIndex + (deltaX < 0 ? 1 : -1);
      }

      activePointerId = null;
      window.requestAnimationFrame(() => scrollToGalleryItem(gallery, targetIndex));
    };

    gallery.addEventListener('pointerup', finishSwipe);
    gallery.addEventListener('pointercancel', finishSwipe);

    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      event.preventDefault();
      const items = getGalleryItems(gallery);
      const currentIndex = getNearestIndex(gallery, items);
      scrollToGalleryItem(gallery, currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });

    return true;
  };

  const enhanceVenue = () => {
    const venueSection = document.getElementById('cc-venue');
    if (!venueSection) return false;
    if (venueSection.querySelector('.cc-venue-photo')) return true;

    const venueName = venueSection.querySelector('.cc-venue-name');
    if (!venueName) return false;

    const figure = document.createElement('figure');
    figure.className = 'cc-venue-photo';

    const image = document.createElement('img');
    image.src = venueImageUrl;
    image.alt = 'Citystate Asturias Hotel Palawan venue and swimming pool at night';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.draggable = false;

    figure.appendChild(image);
    venueName.before(figure);
    return true;
  };

  const enhanceFaqArrows = () => {
    const triggers = Array.from(document.querySelectorAll('.cc-faq-trigger'));
    if (!triggers.length) return false;

    triggers.forEach((trigger) => {
      const arrow = trigger.querySelector('.cc-faq-chevron');
      if (!arrow) return;

      if (arrow.dataset.iconEnhanced !== 'true') {
        arrow.dataset.iconEnhanced = 'true';
        arrow.innerHTML = `
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <circle class="cc-faq-chevron-circle" cx="12" cy="12" r="10.5" />
            <path class="cc-faq-chevron-path" d="M7.5 9.5 12 14l4.5-4.5" />
          </svg>
        `;
      }

      if (trigger.dataset.arrowAnimationBound === 'true') return;
      trigger.dataset.arrowAnimationBound = 'true';

      let popTimeout = null;
      const stopPress = () => trigger.classList.remove('is-arrow-pressing');

      trigger.addEventListener('pointerdown', () => {
        trigger.classList.add('is-arrow-pressing');
      });
      trigger.addEventListener('pointerup', stopPress);
      trigger.addEventListener('pointercancel', stopPress);
      trigger.addEventListener('pointerleave', stopPress);

      trigger.addEventListener('click', () => {
        stopPress();
        trigger.classList.remove('cc-faq-arrow-pop');
        void arrow.offsetWidth;
        trigger.classList.add('cc-faq-arrow-pop');

        if (popTimeout) window.clearTimeout(popTimeout);
        popTimeout = window.setTimeout(() => {
          trigger.classList.remove('cc-faq-arrow-pop');
          popTimeout = null;
        }, 560);
      });
    });

    return true;
  };

  const enhanceInvitation = () => {
    enhanceGallery();
    enhanceVenue();
    enhanceFaqArrows();
  };

  ensureStyles();
  enhanceInvitation();

  const root = document.getElementById('root') || document.body;
  const observer = new MutationObserver(enhanceInvitation);
  observer.observe(root, { childList: true, subtree: true });
}
